





















































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "./Loading.vue";
import ShowMoreView from "../controls/ShowMoreView.vue";
import SettingsLocationForm from "../settings/SettingsLocationForm.vue";

import LocationJson from "../../shared/LocationJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateItemImageJson, validateItemImageJsonAdd } from "../../shared/ItemImageJson";

export default Vue.extend({
  name: "LocationInput",
  components: {
    Loading,
    ShowMoreView,
    SettingsLocationForm,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Object as PropType<LocationJson>,
    editable: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      allLocations: null as LocationJson[] | null,
      details: null as LocationJson | null,
      showLocationDetails: false as boolean,
      selectedLocationId: null as number | null,
      detailsMode: "read",
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    /*** START: details view ***/
    toggleLocationDetails() {
      (this.$refs["showmore-locationDetails"] as any).toggleExpandable();
      this.showLocationDetails = !this.showLocationDetails;
      if (this.showLocationDetails == false) {
        this.loadLocations();
      }
    },

    openLocationDetails(item: LocationJson | null, mode: string) {
      if (item != null) {
        this.selectedLocationId = item.ID;
      } else {
        this.selectedLocationId = null;
      }

      this.detailsMode = mode;
      this.toggleLocationDetails();
    },
    /*** END: details view ***/

    init() {
      this.details = this.data;

      this.loadLocations();
    },

    async loadLocations() {
      if (this.restClient != null) {
        this.allLocations = null;

        try {
          this.allLocations = await this.restClient.getLocations();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //START set cached data

    //END set cached data

    //START set input data (where data be cached)

    //END set input data (where data be cached)
  },

  watch: {
    details: {
      handler() {
        this.$emit("change", this.details);
      },
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
